export const WEBSTORAGE_CONFIG = {
    prefix: 'novolearning-studio',
    separator: '.'
};